<template>
  <div>
    <el-dialog :title="'Modificar horario: ' + student.fullname" :visible.sync="dialogVisible" :before-close="handleCancel" width="30%">
      <el-row :gutter="20" type="flex" justify="center">
        <el-select v-model="timetable_id" filterable placeholder="Seleccionar horario">
          <el-option
            v-for="timetable in timetables"
            :key="timetable.id"
            :label="timetable.name"
            :value="timetable.id">
          </el-option>
        </el-select>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel()">Cancelar</el-button>
        <el-button type="primary" @click="handleSubmit()">Confirmar</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    props: ['dialogVisible','student', 'courseId', 'timetableId'],
    data() {
      return {
        timetables: [],
        timetable_id: '',
      }
    },
    created() {
      this.fetchTimetables();
    },
    methods: {
      fetchTimetables() {
        axios.get(`get-timetable-course/${this.courseId}`)
        .then(res => {
          this.timetables = res.data['timetables'];
          this.timetable_id = this.timetableId;
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      handleSubmit() {
        axios.put(`enrolments-json/${this.student.enrolment_id}/update`, {
          'timetable_id': this.timetable_id,
        })
        .then(res => {
          this.$message({
            message: res.data,
            type: 'success',
            duration: 5000,
          });
          this.handleCancel();
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      handleCancel(done) {
        this.$emit('dialogVisible', false);
      },
    },
  }
</script>
<style scoped>
  .v-modal {
    z-index: 0 !important;
  }
</style>